<template>
	<div>
		<div class="fullPageContent closed">
			<DashboardHeader
				v-bind:showMobileRightMenu="this.$store.getters['user/isLoggedIn']"
				v-bind:title="pageTitle" 
				v-bind:activeEl="activeEl">
			</DashboardHeader>
			<section class="allP wp1200">
				<FAQ></FAQ>
			</section>
		</div>
	</div>
</template>

<script>
import  DashboardHeader from './partials/DashboardHeader.vue';
import  FAQ from './HelpAndSupport/Faq.vue';

export default {
	data() {
		return {
			activeEl:7,
			pageTitle:this.$t("dashboard.help_and_support")
		};
	},
	computed: {},
	components: {
		DashboardHeader,
		FAQ
	},
	mounted() {
		this.$store.dispatch("app/loader", false);
	},
};
</script>

<style>
.vue-typer .custom.char.typed {
  color: #ffffff;
}
.vue-typer .custom.caret {
  display: none;
}
</style>